import * as cnt from './constants';

export const getConnections = () => ({ type: cnt.CONNECTIONS_FETCH });
export const selectConnection = (connection) => ({ type: cnt.CONNECTIONS_SELECT, payload: connection });
export const archiveConnection = (connection) => ({ type: cnt.CONNECTIONS_ARCHIVE, payload: connection });
export const getChannels = (payload) => ({ type: cnt.CHANNELS_FETCH, payload });
export const selectChannel = (channel) => ({ type: cnt.CHANNELS_SELECT, payload: channel });
export const resetChannels = (channel) => ({ type: cnt.CHANNELS_RESET, payload: channel });
export const resetConversations = (channel) => ({ type: cnt.CONVERSATIONS_RESET, payload: channel });
export const archiveConversation = (channel, contract) => ({ type: cnt.CHANNELS_ARCHIVE, payload: { channel, contract } });
export const sendMessage = (message) => ({ type: cnt.MESSAGE_CREATE, payload: message });
export const selectContract = (contractId) => ({ type: cnt.CONTRACT_SELECT, payload: contractId });
export const getConversations = () => ({ type: cnt.CONVERSATIONS_FETCH });
export const markRead = () => ({ type: cnt.CONVERSATIONS_READ });
export const markReadWithParams = (payload) => ({ type: cnt.CONVERSATIONS_READ_WITH_PARAMS, payload });
export const getStatusMessages = () => ({ type: cnt.STATUS_MESSAGES });
export const removeConnectionFromStatus = payload => ({ type: cnt.STATUS_MESSAGES_REMOVE_CONNECTION, payload });
export const changeSelection = (connection, channel) => ({ type: cnt.CHANGE_SELECTION, payload: { connection, channel } });
export const deleteMessage = (message) => ({ type: cnt.MESSAGE_DELETE, payload: message });
export const addFilesToContract = (message) => ({ type: cnt.MESSAGE_ADD_FILES_TO_CONTRACT, payload: message });
export const markAcceptedRead = (payload) => ({ type: cnt.STATUS_CONNECTIONS_MARK_READ, payload });



// WEBPACK FOOTER //
// ./src/app/components/workspace/store/actions.js